
const HeroSection = () => {

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container px-4 mx-auto max-w-6xl">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 leading-tight mb-4">
              Discover Your Ideal <span className="text-brand-blue">Career Path</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto lg:mx-0">
              Take our comprehensive assessment to uncover your strengths, interests, and the career paths 
              that align with your unique profile.
            </p>
          </div>
          <div className="flex-1">
            <img 
              src="/lovable-uploads/437a4af0-d288-45df-9749-9d27fcb14913.png" 
              alt="IKIGAI Diagram - Finding your career purpose" 
              className="w-full max-w-md mx-auto rounded-lg shadow-lg" 
              width={500} 
              height={500}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
